var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10197",
    "data-name": "Group 10197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.677,
    height: 70.321,
    viewBox: "0 0 107.677 70.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3565",
    "data-name": "Rectangle 3565",
    width: 107.677,
    height: 70.321,
    fill: "#00a4dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10196",
    "data-name": "Group 10196",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32404",
    "data-name": "Path 32404",
    d: "M44.189,31.629A14.823,14.823,0,1,1,59.013,16.807,14.834,14.834,0,0,1,44.189,31.629m0-21.856A7.017,7.017,0,1,0,51.2,16.787a7.026,7.026,0,0,0-7.014-7.014M72.31,70.321h-55.1a3.909,3.909,0,0,1-3.9-3.906,31.452,31.452,0,0,1,62.9,0,3.9,3.9,0,0,1-3.9,3.906m-50.87-7.79H68.083a23.646,23.646,0,0,0-46.643,0M76.2,23.421A11.71,11.71,0,1,1,87.909,11.707,11.724,11.724,0,0,1,76.2,23.421M76.2,7.8a3.9,3.9,0,1,0,3.9,3.906A3.91,3.91,0,0,0,76.2,7.8",
    transform: "translate(9.087)",
    fill: "#00a4dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32405",
    "data-name": "Path 32405",
    d: "M103.793,51.4H73.858a3.9,3.9,0,0,1-3.668-5.245,3.906,3.906,0,0,1-5.858-4.293A22.038,22.038,0,0,1,107.677,47.5a3.859,3.859,0,0,1-3.884,3.9M85.649,33.267A14.247,14.247,0,0,0,71.886,43.849a2.447,2.447,0,0,1-.119.355,3.865,3.865,0,0,1,2.092-.6H99.335A14.23,14.23,0,0,0,85.649,33.267M21.672,23.421A11.71,11.71,0,1,1,33.386,11.707,11.719,11.719,0,0,1,21.672,23.421m0-15.619a3.9,3.9,0,1,0,3.9,3.906,3.914,3.914,0,0,0-3.9-3.906M33.827,51.4H3.9A3.887,3.887,0,0,1,0,47.518a22.044,22.044,0,0,1,43.351-5.654,3.9,3.9,0,0,1-5.876,4.274,4.13,4.13,0,0,1,.256,1.36,3.9,3.9,0,0,1-3.9,3.9M8.348,43.614H33.827a3.908,3.908,0,0,1,2.1.6,2.146,2.146,0,0,1-.119-.369,14.242,14.242,0,0,0-27.463-.236",
    fill: "#00a4dd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon1);
export default __webpack_public_path__ + "static/media/merchant-icon1.ffbc7c08a6660c515aad35d1f94e7085.svg";
export { ForwardRef as ReactComponent };